import { useEffect, useRef } from 'react'
import Post, { PostRef } from 'organisms/Post'
import { toPng } from 'html-to-image'
import DownloadIcon from 'atoms/icons/DownloadIcon'
import { useAtom } from 'jotai'
import { itemsDataAtom } from 'store/atoms'
import PostSelectedItemTools from 'organisms/post-tools/PostSelectedItemTools'

function PostManager() {
  const postRef = useRef<PostRef>(null)

  // This code guarantee itemsData and itemsRef to be sync
  useEffect(() => {
    if (Object.values(itemsData).some(item => !item.loaded)) {
      setItemsData(oldState => {
        const newState = { ...oldState }
        Object.values(itemsData).forEach(item => {
          if (!item.loaded) newState[item.id].loaded = true
        })
        return newState
      })
    }
  }, [postRef.current])

  const [itemsData, setItemsData] = useAtom(itemsDataAtom)

  return (
    <div className='w-full grid grid-cols-12 grid-rows-1 gap-4 items-start'>
      <div
        className='xs:max-lg:col-span-12 lg:max-2xl:col-span-8 col-span-6
      xs:max-lg:col-start-1 col-start-2
      border-8 border-black rounded-lg'>
        <Post ref={postRef} />
      </div>
      <div className='xs:max-lg:col-span-12 lg:max-2xl:col-span-4 col-span-4 grid grid-cols-2 gap-2 content-start'>
        <button
          className='w-full btn btn-outline btn-success'
          onClick={() => {
            if (postRef.current === null || postRef.current?.previewRef === null) return

            toPng(postRef.current.previewRef, {
              cacheBust: true,
              fetchRequestInit: {
                method: 'GET',
                cache: 'no-cache'
              }
            })
              .then(dataUrl => {
                const link = document.createElement('a')
                link.download = 'my-image-name.png'
                link.href = dataUrl
                link.click()
              })
              .catch(err => {
                console.log('toPng error', err)
              })
          }}>
          <DownloadIcon />
          Download
        </button>
        <PostSelectedItemTools />
      </div>
    </div>
  )
}

export default PostManager
